import i18n from "../i18n";
import { isBinapsisBrand } from "./utils";

export function getApiLocale() {
  if (!isBinapsisBrand()) return "es";
  return i18n.language === "en" ? "en" : "es";
}

export function apiJsonHeaders(extra = {}) {
  return {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Accept-Language": getApiLocale(),
    ...extra,
  };
}

export function withApiLocale(body = {}) {
  return { ...body, locale: getApiLocale() };
}
